import { render, staticRenderFns } from "./PolicyEdit.vue?vue&type=template&id=e40130ce&scoped=true"
import script from "./PolicyEdit.vue?vue&type=script&lang=js"
export * from "./PolicyEdit.vue?vue&type=script&lang=js"
import style0 from "./PolicyEdit.vue?vue&type=style&index=0&id=e40130ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40130ce",
  null
  
)

export default component.exports